import { $http } from "@/plugins/axios";

export default {
  namespaced: true,
  state: {
    form: {
      text: null,
      system_details: null,
      covered_locations: null,
      service_process: null,
      warranty_type: null,
      warranty_duration: null,
      equipment_origin: null,
      pricing: null,
      document: null,
      status: null,
    },
  },
  mutations: {
    SET_TEXT: (state, data) => (state.form = data),
  },
  actions: {
    async get({ commit }) {
      const { payload } = await $http.get(`company-admin/company-services`);
      if (Array.isArray(payload.data) && payload.data.length > 0) {
        commit("SET_TEXT", payload.data[0]);
      }
    },
    async update({ state }) {
      return await $http.post(`company-admin/company-services`, state.form);
    },
  },
};
